import React from 'react';
import styled from 'styled-components';

const Background = styled.div`
    background-color: #d3d3d3;
    height: 100vh;
    width: 100vw;
`;

const Heading = styled.h1`
    padding-top: 0.8em;
    text-align: center;
    font-size: 3em;
`;

const SalaryForm = styled.form`
    display: flex;
    flex-direction: column;
    width: 45%;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 2em;
`;

const Input = styled.input`
    width: 100%;
    border: none;
    padding: 8px;
    border-radius: 6px;
    margin: 0.4em 1em 1em 1em;
    font-size: 2em;
`;

const Btn = styled.button`
    margin: 0px 0px 20px 0px;
    width: 100%;
    padding: 10px;
    border: none;
    background-color: ${({ btnType }) => btnType === 'clear' ? '#f76969' : '#72c0f1' };
    border-radius: 10px;
    font-size: 2em;
    font-weight: 100;
`;

const Label = styled.label`
    font-size: 1.4em;
    align-self: flex-start;
`;

export const SalaryCalc = () => {
    const [total, setTotal] = React.useState(0);
    const [totalNumeric, setTotalNumeric] = React.useState(null);

    const calculateSalary = (evt) => {
        evt.preventDefault();
        const formData = new FormData(evt.target);
        const salary = formData.get('salary');
        const hike = formData.get('hike');
        const total = parseFloat(((salary * hike) / 100)) + parseFloat(salary);
        setTotal(total);
        const totalString = String(total);
        const numLength = (total.toFixed()).length;
        switch (numLength) {
        case 5: {
            setTotalNumeric(`
                ${totalString[0]}${totalString[1]} Thousand 
                ${totalString[2]}${totalString[3]}${totalString[4]}`);
            break;
        }

        case 6: {
            setTotalNumeric(`
                ${totalString[0]} Lakh 
                ${totalString[1]}${totalString[2]} Thousand`);
            break;
        }

        case 7: {
            setTotalNumeric(`
                ${totalString[0]}${totalString[1]} Lakh 
                ${totalString[2]}${totalString[3]} Thousand`);
            break;
        }

        case 8: {
            setTotalNumeric(`
                ${totalString[0]} Crore 
                ${totalString[1]}${totalString[2]} Lakh 
                ${totalString[3]}${totalString[4]} Thousand`);
            break;
        }

        case 9: {
            setTotalNumeric(`
                ${totalString[0]}${totalString[1]} Crore 
                ${totalString[2]}${totalString[3]} Lakh 
                ${totalString[4] === '0' ? '' : totalString[4]+totalString[5]+' Thousand'}`);
            break;
        }
        default: {
            setTotalNumeric(null);
        }
        }
    };

    const clear = (evt) => {
        evt.preventDefault();
        document.getElementById('salary').value = '';
        document.getElementById('hike').value = '';
        setTotal(0);
        setTotalNumeric(null);
    };

    return (
        <Background>
            <Heading>SALARY Calculator</Heading>
            <SalaryForm onSubmit={calculateSalary}>
                <Label>Enter Salary</Label>
                <Input type='number' step=".001" name='salary' id='salary' />
                <Label>Enter Percentage</Label>
                <Input type='number' name='hike' id='hike' />
                <Btn btnType='submit' type='submit'>Calculate</Btn>
                <Btn btnType='clear' type='button' onClick={clear}>Clear</Btn>
                <h1>{total ? total : ''}</h1>
                {totalNumeric ? (
                    <>
                        <br/>
                        <h4>or</h4>
                        <br/>
                        <h2 style={{ textAlign: 'center' }}>{totalNumeric}</h2>
                    </>
                ) : ''}
            </SalaryForm>
        </Background>
    );
};
